import { render, staticRenderFns } from "./ModalDeleteConfirmation.vue?vue&type=template&id=2f488a08&"
import script from "./ModalDeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports